import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SankhyaEnvelope} from './sankhya-gateway.service';

export interface SerialDisponivel {
    serie: string;
    serieFab: string;
}

export interface SerialAtribuido {
    sequencia: number;
    codProd: number;
    serie: string;
    serieFab: string;
}

export interface SeriaisDisponiveisResponse {
    sucesso: boolean;
    lista: SerialDisponivel[];
}

export interface SeriaisNota {
    sucesso: boolean;
    lista: SerialAtribuido[];
}

export interface AtribuicaoAutomaticaResponse {
    sucesso: boolean;
    atribuidos: SerialAtribuido[];
    erro?: string;
}

@Injectable({providedIn: 'root'})
export class SerialService {
    private readonly apiUrl = '/api/sankhya/serial';

    constructor(private readonly http: HttpClient) {
    }

    /** Seriais disponíveis em estoque para um produto (ATUALESTOQUE = 1). */
    buscarSeriesDisponiveis(codProd: number): Observable<SankhyaEnvelope<SeriaisDisponiveisResponse>> {
        return this.http.post<SankhyaEnvelope<SeriaisDisponiveisResponse>>(
            `${this.apiUrl}/disponiveis`, {codProd}
        );
    }

    /** Seriais já atribuídos a um pedido/nota (ATUALESTOQUE = -1). */
    buscarSeriesPorNota(nuNota: number): Observable<SankhyaEnvelope<SeriaisNota>> {
        return this.http.post<SankhyaEnvelope<SeriaisNota>>(
            `${this.apiUrl}/por-nota`, {nuNota}
        );
    }

    /**
     * Atribui automaticamente (FIFO) o serial mais antigo disponível
     * para todos os itens com TIPCONTEST='E' do pedido.
     * Chamado logo após salvar o pedido.
     */
    atribuirSeriaisAutomaticos(nuNota: number): Observable<SankhyaEnvelope<AtribuicaoAutomaticaResponse>> {
        return this.http.post<SankhyaEnvelope<AtribuicaoAutomaticaResponse>>(
            `${this.apiUrl}/atribuir-automatico`, {nuNota}
        );
    }

    /** Registra manualmente a saída de um serial específico para um item. */
    registrarSerialSaida(nuNota: number, codProd: number, sequencia: number, serie: string): Observable<SankhyaEnvelope<{
        sucesso: boolean
    }>> {
        return this.http.post<SankhyaEnvelope<{ sucesso: boolean }>>(
            `${this.apiUrl}/registrar-saida`, {nuNota, codProd, sequencia, serie}
        );
    }

    /** Remove atribuição manual de um serial (cancelamento). */
    removerSerialSaida(nuNota: number, sequencia: number, serie: string): Observable<SankhyaEnvelope<{
        sucesso: boolean
    }>> {
        return this.http.post<SankhyaEnvelope<{ sucesso: boolean }>>(
            `${this.apiUrl}/remover-saida`, {nuNota, sequencia, serie}
        );
    }
}
